import { fbt } from 'fbtee'
import { PillButton } from '../PillButton'
import type { ProfileTab } from './profileTabs'

export function ProfilePillNav({
  tab,
  onTabChange,
}: {
  tab: ProfileTab
  onTabChange: (t: ProfileTab) => void
}) {
  return (
    <div className="flex gap-1 shrink-0">
      <PillButton active={tab === 'events'} onClick={() => onTabChange('events')}>
        {fbt('Events', 'Pill nav label for the events tab on a profile page')}
      </PillButton>
      <PillButton active={tab === 'artists'} onClick={() => onTabChange('artists')}>
        {fbt('Artists', 'Pill nav label for the artists tab on a profile page')}
      </PillButton>
    </div>
  )
}
